import { render } from "./NoticesList.vue?vue&type=template&id=2dfab19f"
import script from "./NoticesList.vue?vue&type=script&lang=js"
export * from "./NoticesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__